import { h } from 'preact'
import TopicPreviewNotice from './TopicPreviewNotice'
import ArticlePreview from './ArticlePreview'
import ProductUpdatePreview from './ProductUpdatePreview'
import { ArticleType } from '../articles-destination/Types'
import { ProductUpdateType } from '../product-updates-destination/Types'
import tracker from '../../components/tracker/publish'

type Props = {
  topic: ProductUpdateType | ArticleType,
  contentType: string
}

const trackTopicPreviewed = (topic: ProductUpdateType | ArticleType, contentType: string) => {
  const user = window.inSidedData.user
  tracker.trackEvent('userevent', {
    'type': 'Topic Previewed',
    'id': topic.id,
    'url': window.location.href,
    'title': topic.title,
    'userid': user.userid,
    'user_primary_role': user.mainRole,
    'user_custom_roles': user.role,
    'user_name': user.name,
    'user_email': user.email,
    'isPreviewPublic': topic.isPreviewPublic,
    'content_type': contentType
  })
}

const renderTopicPreview = (topic: ProductUpdateType | ArticleType, contentType: string) => {
  switch (contentType) {
    case 'article':
      return <ArticlePreview topic={topic as ArticleType} />
    case 'productUpdate':
      return <ProductUpdatePreview topic={topic as ProductUpdateType} />
    default:
      return null
  }
}

const TopicPreview = ({ topic, contentType }: Props) => {
  trackTopicPreviewed(topic, contentType)
  return (
    <div>
      <TopicPreviewNotice isPreviewPublic={topic.isPreviewPublic} />
      { renderTopicPreview(topic, contentType) }
    </div>
  )
}

export default TopicPreview
